import { apiClient } from './client';
import { API_CONFIG } from './config';

export type RoleAccessEntity = {
  roleAccessId: string;
  projectId: string | null;
  projectCode: string | null;
  role: string;
  isHidden: boolean;
  project: boolean;
  dashboard: boolean;
  ecommerce: boolean;
  user: boolean;
  customer: boolean;
  notification: boolean;
  custom: boolean;
  booking: boolean;
  reward: boolean;
  rental: boolean;
  createdAt: string;
  updatedAt: string;
};

export type RoleAccessListResponse = {
  data: RoleAccessEntity[];
};

export type CreateRoleAccessRequest = Partial<Omit<RoleAccessEntity, 'roleAccessId' | 'projectId' | 'projectCode' | 'createdAt' | 'updatedAt'>> & {
  role: string;
};

export type UpdateRoleAccessRequest = Partial<Omit<RoleAccessEntity, 'roleAccessId' | 'projectId' | 'projectCode' | 'createdAt' | 'updatedAt'>>;

class RoleAccessApi {
  private ep = API_CONFIG.endpoints.roleAccess;

  list(projectId?: string) {
    return apiClient.get<RoleAccessListResponse>(this.ep.list, {
      params: projectId ? { projectId } : undefined,
    });
  }

  create(data: CreateRoleAccessRequest & { projectId?: string; projectCode?: string }) {
    return apiClient.post<RoleAccessEntity>(this.ep.create, data);
  }

  update(id: string, data: UpdateRoleAccessRequest) {
    return apiClient.patch<RoleAccessEntity>(this.ep.update(id), data);
  }

  delete(id: string) {
    return apiClient.delete(this.ep.delete(id));
  }
}

export const roleAccessApi = new RoleAccessApi();
